import './styles.scss'
import { autoInit } from './base'
import plugin from './index.js'
export default plugin

autoInit(plugin)
